import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideEnvironmentInitializer,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { tokenInterceptor } from './core/interceptors/token';
import { eventSourceUrlInterceptor } from './core/interceptors/event-source-url';
import { trimInterceptor } from './core/interceptors/trim';
import { clearLegacyBrowserStorage } from './core/utils/clear-legacy-browser-storage';
import { captureCampaignVisit } from './core/utils/capture-utm';
import { APP_LOCALE } from './core/i18n/app-locale';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: APP_LOCALE },
    provideEnvironmentInitializer(clearLegacyBrowserStorage),
    provideEnvironmentInitializer(captureCampaignVisit),
    provideBrowserGlobalErrorListeners(),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({ includeRequestsWithAuthHeaders: true })
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        tokenInterceptor,
        eventSourceUrlInterceptor,
        trimInterceptor,
      ])
    ),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      })
    ),
  ],
};
